var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNiko(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "79px",
    height: "24px",
    viewBox: "0 0 79 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    troke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-141.000000, -24.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(141.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.8883721,14.1209302 C71.4418605,17.3023256 70.2697674,21.0976744 67.0325581,21.1534884 C63.8511628,21.0976744 63.627907,17.3581395 64.0744186,14.1209302 C64.5209302,10.8837209 65.6930233,7.08837209 68.9860465,6.92093023 C72.4465116,6.80930233 72.3348837,10.9395349 71.8883721,14.1209302 M70.9395349,4.74418605 C61.172093,4.01860465 58.2697674,9.20930233 57.544186,14.1209302 C56.2604651,22.8837209 63.627907,23.2744186 63.627907,23.2744186 C63.627907,23.2744186 67.8697674,23.944186 71.2186047,22.9395349 C75.5162791,21.7116279 77.7488372,18.3069767 78.3627907,14.1209302 C79.2,8.26046512 76.9674419,5.19069767 70.9395349,4.74418605",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82325581,5.02325581 L3.01395349,5.02325581 L0.334883721,23.0511628 L7.14418605,23.0511628 L9.48837209,7.31162791 C9.71162791,7.31162791 9.99069767,7.25581395 10.3255814,7.2 C16.4093023,6.08372093 16.4093023,8.7627907 16.1860465,10.2139535 L14.2883721,23.0511628 L21.0976744,23.0511628 L23.0511628,10.0465116 C23.3302326,7.81395349 22.3255814,3.40465116 9.82325581,5.02325581",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0139535,12.6139535 C52.2976744,12.2790698 54.027907,11.7767442 54.3627907,9.54418605 L55.0883721,4.96744186 L48.2232558,4.96744186 L47.6093023,9.04186047 C47.6093023,9.04186047 47.2186047,11.7209302 43.6465116,11.4418605 L45.2651163,0.223255814 L38.455814,0.223255814 L35.1069767,22.9953488 L41.972093,22.9953488 L43.2,14.7348837 C43.4232558,14.7348837 43.4790698,14.7348837 43.8139535,14.6790698 C49.5627907,13.7860465 48.6139535,17.6930233 48.6139535,17.6930233 L47.8325581,22.9953488 L54.6976744,22.9953488 L55.2,19.144186 C55.8697674,14.8465116 53.6930233,13.172093 51.0139535,12.6139535",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.2883721 10.8837209 24.5023256 23.0511628 31.3116279 23.0511628 33.0976744 10.8837209"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "33.9906977 4.68837209 27.1813953 4.68837209 26.5674419 8.8744186 33.3767442 8.8744186"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiko);
export default __webpack_public_path__ + "static/media/niko.d8e10e87eaf594a7e7e1249e9405a7f7.svg";
export { ForwardRef as ReactComponent };